import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      tagline: "visualize•organize•realize",
      description: "visualize • organize • realize",
      wantToKnowMore: "Visit our web site to learn more about FocusMap",
      explanation: {
        part1:
          "FocusMap is a structured visual tool that helps users outline a primary goal, or “focus,” with related ideas, tasks, or objectives branching out from it.",
        part2:
          "Unlike traditional mind mapping, which encourages freeform exploration around a central concept, FocusMap promotes a structured, goal-oriented approach, guiding users to break down objectives into clear, actionable steps. With FocusMap, users can also add metrics (such as numbers, checkboxes and dates) that roll up through each branch, providing a comprehensive status overview and supporting data-driven analysis at every level.",
        part3:
          "This targeted, metrics-driven approach makes FocusMap an ideal solution for individuals and teams who need a focused alternative to general brainstorming, uniquely positioning it among productivity and mind-mapping tools.",
        contactUs: "For more information, please don't hesitate to",
        contactEmail: "contact us",
      },
      signIn: "Sign up / Log in",
      email: "Email",
      password: "Password",
      signInWithEmail: "Sign in with Email",
      signUpWithEmail: "Sign up with Email",
      signInWithGoogle: "Sign in with Google",
      signInWithMicrosoft: "Sign in with Microsoft",
      signInWithApple: "Sign in with Apple",
      error: {
        signInFailed: "Failed to sign in. Please try again.",
        invalidEmail: "Invalid email address.",
        userDisabled: "User account is disabled.",
        userNotFound: "No user found with this email.",
        wrongPassword: "Incorrect password.",
      },
      officialHomePage: "Our Official Home Page",
    },
  },
  da: {
    translation: {
      tagline: "visualize•organize•realize",
      description:
        "Visualisering, der transformerer ideer til strukturerede planer og målbare succeser.",
      wantToKnowMore: "Vil du vide mere?",
      explanation: {
        part1:
          "FocusMap er et struktureret visuelt værktøj, der hjælper brugere med at skitsere et primært mål, eller “fokus,” med relaterede ideer, opgaver eller mål, der forgrener sig fra det.",
        part2:
          "I modsætning til traditionel mind mapping, som opmuntrer til fri udforskning omkring et centralt koncept, fremmer FocusMap en struktureret, målorienteret tilgang, der guider brugere til at nedbryde mål til klare, handlingsrettede trin. Med FocusMap kan brugere også tilføje metrics (såsom tal, afkrydsningsfelter og datoer), der ruller op gennem hvert niveau, hvilket giver et omfattende statusoverblik og understøtter datadrevet analyse på hvert niveau.",
        part3:
          "Denne målrettede, metrics-drevne tilgang gør FocusMap til en ideel løsning for enkeltpersoner og teams, der har brug for et fokuseret alternativ til generel brainstorming, og placerer det unikt blandt produktivitets- og mind-mapping-værktøjer.",
        contactUs: "For mere information, tøv ikke med at",
        contactEmail: "kontakte os",
      },
      signIn: "Log ind",
      email: "Email",
      password: "Adgangskode",
      signInWithEmail: "Log ind med Email",
      signUpWithEmail: "Tilmeld dig med Email",
      signInWithGoogle: "Log ind med Google",
      signInWithMicrosoft: "Log ind med Microsoft",
      signInWithApple: "Log ind med Apple",
      error: {
        signInFailed: "Kunne ikke logge ind. Prøv igen.",
        invalidEmail: "Ugyldig email-adresse.",
        userDisabled: "Brugerkontoen er deaktiveret.",
        userNotFound: "Ingen bruger fundet med denne email.",
        wrongPassword: "Forkert adgangskode.",
      },
      officialHomePage: "Vores officielle Web Site",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en", // default language
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
